import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Contact } from '../../../types/Contact';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';

export const postContact = async (formData: Contact) => {
  const response = await CustomAxios.post(`contacts`, formData);
  const { data } = response;
  return data;
};

type useCreateContactProps = {
  onSuccessCallback: (contact: Contact) => void;
};
export function useCreateContact({ onSuccessCallback }: useCreateContactProps) {
  return useMutation({
    mutationKey: [mutationKeys.createContact],
    mutationFn: (formData: Contact) => postContact(formData),
    onSuccess: (contact: Contact) => {
      // fetch the contacts again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allContacts, 'new'] });

      // call success
      onSuccessCallback(contact);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const contact: Contact = err.response.data as Contact;
        queryClient.setQueryData([queryKeys.allContacts, 'new'], contact);
      }
    },
  });
}
